<template>
  <v-card class="min-height fluid-modal order-summary-modal-box">
    <nav
      class="v-toolbar theme--dark bg-success-color"
      data-booted="true"
      style="margin-top: 0px; padding-right: 0px; padding-left: 0px; transform: translateY(0px);"
    >
      <div class="v-toolbar__content">
        <div class="v-toolbar__title text-white">Payment Summary</div>
        <div class="spacer"></div>
        <button
          v-if="
            orderSummary.appointmentType !== 'Appointment' ||
              orderSummary.appointmentType !== 'fromAccounts'
          "
          @click="closeModal(false, orderSummary)"
          type="button"
          class="v-btn v-btn--icon theme--dark common-color"
        >
          <div class="v-btn__content">
            <i aria-hidden="true" class="v-icon material-icons theme--dark"
              >close</i
            >
          </div>
        </button>
      </div>
    </nav>
    <v-card-text v-if="orderSummary.appointmentType === 'Doctor-Subscription'">
      <div class="order-summery p-0">
        <div class="col-sm-12 p-0">
          <div class="table-div border-0 p-0">
            <table class="table ww-100 text-left">
              <thead class="os_thead">
                <tr>
                  <th>{{ dr_label }} Name</th>
                  <th>Plan</th>
                  <th>Date of purchase</th>
                  <th>Validity of purchase</th>
                  <th>Plan activation date</th>
                  <th>Expiry Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody class="os_tbody">
                <tr>
                  <td>
                    <p class="text-capitalize">
                      <b>{{ dr_label + orderSummary.doctorName }}</b>
                    </p>
                    <p>{{ orderSummary.doctorType }}</p>
                  </td>
                  <td>
                    <p>{{ orderSummary.name }}</p>
                  </td>
                  <td>
                    <p>{{ getDate(orderSummary.dateOfPurchase) }}</p>
                  </td>
                  <td>
                    <p>{{ orderSummary.validity }}</p>
                  </td>
                  <td>
                    <p>{{ getDate(orderSummary.activationDate) }}</p>
                  </td>
                  <td>
                    <p>{{ getDate(orderSummary.expiryDate) }}</p>
                  </td>
                  <td>
                    <p>&#8377; {{ orderSummary.planAmount }}</p>
                  </td>
                </tr>
                <tr class="maain_table">
                  <td colspan="3">
                    <!-- <p>
                      <b>{{ dr_label + orderSummary.doctorName }}</b>
                    </p>-->
                  </td>
                  <td colspan="2">
                    <div v-if="wallet > 0" class="d-align">
                      <div class="wallet-icon-div">
                        <wallet-SVG />
                      </div>

                      <div>
                        <p class="mb-1">
                          <b>YOU HAVE &nbsp;</b>
                          <span>
                            <b>&#8377;{{ walletAmount | round }}</b>
                          </span>
                        </p>
                        <label class="container-check container-check-fluid">
                          <b>Use Wallet</b>
                          <input v-model="useWallet" type="checkbox" />
                          <span class="checkmarked"></span>
                        </label>
                      </div>
                    </div>
                  </td>
                  <td colspan="2">
                    <p class="mb-3">Payment Summary</p>
                    <div
                      v-for="item in transaction.items"
                      :key="item.name"
                      class="d-align"
                    >
                      <p class="no-break-word">{{ item.name }}</p>
                      <p class="no-break-word">
                        &#8377; {{ item.price | round }}
                      </p>
                    </div>
                    <div v-if="transaction.discount > 0" class="d-align">
                      <p>Previous Adjustment</p>
                      <p>&#8377; {{ transaction.discount | round }}</p>
                    </div>
                    <div
                      v-if="transaction.platform_charges > 0"
                      class="d-align"
                    >
                      <p>Platform Charges</p>
                      <p>&#8377; {{ transaction.platform_charges | round }}</p>
                    </div>
                    <div v-if="useWallet" class="d-align">
                      <p>Used From Wallet</p>
                      <p>
                        - &#8377;
                        {{
                          payableAmount > walletAmount
                            ? walletAmount.toFixed(2)
                            : payableAmount.toFixed(2)
                        }}
                      </p>
                    </div>
                    <div v-if="utilityCharges > 0" class="d-align">
                      <p>Utility Charges</p>
                      <p>&#8377; {{ utilityCharges | round }}</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="7">
                    <div class="d-align">
                      <p class="text-right mr-2">
                        <b>
                          Total Amount &#8377;
                          {{ totalAmount | round }}
                        </b>
                      </p>
                      <div class="pt-1vw">
                        <v-btn
                          class="btn btn-grn-solid mr-2"
                          v-if="useWallet && payableAmount > walletAmount"
                          @click="doPayment"
                          >Pay Now</v-btn
                        >
                        <v-btn
                          v-else-if="useWallet && payableAmount <= walletAmount"
                          @click="doPayment"
                          class="btn btn-grn-solid mr-2"
                          >Pay Now from wallet</v-btn
                        >
                        <v-btn
                          v-else
                          @click="doPayment"
                          class="btn btn-grn-solid mr-2"
                          >Pay Now</v-btn
                        >
                      </div>
                    </div>
                    <!-- <p>
                      Platform and Facilitation / Utility fees are Non-refundable
                    </p>-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-text
      v-else-if="orderSummary.appointmentType === 'Centre-Subscription'"
    >
      <div class="order-summery p-0">
        <div class="col-sm-12 p-0">
          <div class="table-div border-0 p-0">
            <table class="table ww-100 text-left">
              <thead class="os_thead">
                <tr>
                  <th>Centre Name</th>
                  <th class="min-width-30"></th>
                  <th>Date of purchase</th>
                  <th>Plan activation date</th>
                  <th>Plan name</th>
                  <th>Expiry Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody class="os_tbody">
                <tr v-for="(centre, i) in orderSummary.centresName" :key="i">
                  <td>
                    <p>
                      <b>{{ centre.name }}</b>
                    </p>
                    <p class="capitalize-text">{{ orderSummary.role }}</p>
                  </td>
                  <td class="min-width-30"></td>
                  <td>
                    <p>{{ getDate(orderSummary.dateOfPurchase) }}</p>
                  </td>
                  <td>
                    <p>{{ getDate(orderSummary.activationDate) }}</p>
                  </td>
                  <td>
                    <p>{{ orderSummary.validity }}</p>
                  </td>
                  <td>
                    <p>{{ getDate(orderSummary.expiryDate) }}</p>
                  </td>
                  <td>
                    <p>
                      &#8377;
                      {{
                        orderSummary.planAmount /
                          orderSummary.centresName.length
                      }}
                    </p>
                  </td>
                </tr>
                <tr class="maain_table">
                  <td colspan="3"></td>
                  <td colspan="2"></td>
                  <td colspan="2">
                    <p class="mb-3">Payment Summary</p>
                    <div
                      v-for="item in transaction.items"
                      :key="item.name"
                      class="d-align"
                    >
                      <p>{{ item.name }}</p>
                      <p>
                        &#8377;
                        {{
                          item.name === "Subscription Charges"
                            ? item.price * item.qty
                            : item.price | round
                        }}
                      </p>
                    </div>
                    <div v-if="transaction.discount > 0" class="d-align">
                      <p>Previous Adjustment</p>
                      <p>&#8377; {{ transaction.discount | round }}</p>
                    </div>
                    <div
                      v-if="transaction.platform_charges > 0"
                      class="d-align"
                    >
                      <p>Platform Charges</p>
                      <p>&#8377; {{ transaction.platform_charges | round }}</p>
                    </div>
                    <div v-if="useWallet" class="d-align">
                      <p>Used From Wallet</p>
                      <p>
                        - &#8377;
                        {{
                          payableAmount > walletAmount
                            ? walletAmount
                            : payableAmount
                        }}
                      </p>
                    </div>
                    <div v-if="utilityCharges > 0" class="d-align">
                      <p>Utility Charges</p>
                      <p>&#8377; {{ utilityCharges | round }}</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="7">
                    <div class="d-align">
                      <p class="text-right mr-2">
                        <b
                          >Total Amount &#8377;
                          {{ totalAmount | round }} &nbsp;</b
                        >
                      </p>
                      <div class="pt-1vw">
                        <v-btn
                          class="btn btn-grn-solid mr-2"
                          v-if="useWallet && payableAmount > walletAmount"
                          @click="doPayment"
                          >Pay Now</v-btn
                        >
                        <v-btn
                          v-else-if="useWallet && payableAmount <= walletAmount"
                          @click="doPayment"
                          class="btn btn-grn-solid mr-2"
                          >Pay Now from wallet</v-btn
                        >
                        <v-btn
                          v-else
                          @click="doPayment"
                          class="btn btn-grn-solid mr-2"
                          >Pay Now</v-btn
                        >
                      </div>
                    </div>
                    <p>
                      Subscription validity may be adjusted to match the expiry
                      date of other subscribed centres. The cost shall be
                      calculated accordingly.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-text
      v-else-if="orderSummary.appointmentType === 'Pharmacy-Booking'"
      class="order-summery"
    >
      <div>
        <div class="col-sm-12 nopad">
          <table class="table">
            <thead>
              <tr>
                <th class="w40">
                  <p>Name</p>
                </th>
                <th class="w25">
                  <p>Service Type</p>
                </th>
                <th class="w15">Amount</th>
                <th class="w20"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="w40">
                  <p class="text-dark text-capitalize">
                    <b>{{ orderSummary.doctorName }}</b>
                  </p>
                  <p>{{ orderSummary.doctorType }}</p>
                </td>
                <td class="w25">
                  <p class="text-dark">{{ orderSummary.appointmentType }}</p>
                </td>
                <td class="w15">
                  &#8377;{{ transaction.items | calculateItemTotal }}
                </td>
                <td class="w20"></td>
              </tr>
              <tr>
                <td class="w40">
                  <p class="mb-2 text-dark">
                    <b v-if="showAddress">Address</b>
                  </p>
                  <p>
                    <b>{{ orderSummary.addressName }}</b>
                  </p>
                  <p v-if="showAddress">{{ orderSummary.address }}</p>
                </td>
                <td class="w25">
                  <div v-if="wallet > 0" class="d-align use-wallet">
                    <walletSVG />
                    <div>
                      <p class="mb-2">
                        YOU HAVE
                        <span>
                          <b>&#8377; {{ walletAmount | round }}</b>
                        </span>
                      </p>
                      <label class="container-check container-check-fluid">
                        <b>Use Wallet</b>
                        <input v-model="useWallet" type="checkbox" />
                        <span class="checkmarked"></span>
                      </label>
                    </div>
                  </div>
                  <!-- coupon code -->
                  <!-- <div v-if="isOC" class="mt-4">
                    <div class="coupon-code">
                      <label for>Coupons</label>
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Coupon Code"
                          v-model="code"
                        />
                        <p @click="validateCouponCode" class="mb-0 cursor">Apply</p>
                      </div>
                    </div>
                    <div>
                      <div v-if="codeValid" class="applied-coupon-code">
                        <div class="position-relative">
                          <p class="m-0">{{code}} Coupon Applied</p>
                          <v-icon @click="resetCode" class="cursor text-danger">mdi-close</v-icon>
                        </div>
                      </div>
                      <p
                        v-if="codeValid"
                        class="text-success"
                      >You saved additional &#8377; {{codeAmount}}</p>
                      <small v-if="codeInvalid" class="text-danger">Please enter a Valid Coupon Code</small>
                    </div>
                  </div> -->
                  <!-- end coupon code -->
                </td>
                <td colspan="2">
                  <p class="mb-3">Payment Summary</p>
                  <div class="d-align">
                    <p>Booking amount</p>
                    <p>&#8377; {{ transaction.pending_amount | round }}</p>
                  </div>
                  <div v-if="transaction.platform_charges > 0" class="d-align">
                    <p>Platform Charges</p>
                    <p>&#8377; {{ transaction.platform_charges | round }}</p>
                  </div>
                  <!-- coupon code Discount-->
                  <div v-if="codeAmount > 0" class="d-align">
                    <p>Discount</p>
                    <p>&#8213; &#8377; {{ codeAmount }}</p>
                  </div>
                  <!-- end coupon code Discount-->
                  <div v-if="transaction.paid_amount > 0" class="d-align">
                    <p>Paid Amount</p>
                    <p>
                      - &#8377;
                      {{ transaction.paid_amount | round }}
                    </p>
                  </div>
                  <div v-if="useWallet" class="d-align">
                    <p>Used From Wallet</p>
                    <p>
                      - &#8377;
                      {{
                        payableAmount > walletAmount
                          ? walletAmount.toFixed(2)
                          : payableAmount.toFixed(2)
                      }}
                    </p>
                  </div>
                  <div v-if="utilityCharges > 0" class="d-align">
                    <p>Utility Charges</p>
                    <p>&#8377; {{ utilityCharges | round }}</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p class="text-right">
                    <b>
                      Total Amount
                      <span>&#8377; {{ totalAmount | round }}</span>
                      <!-- <span v-else>&#8377; {{ payableAmount + utilityCharges }}</span> -->
                    </b>
                  </p>
                  <!-- <p class="text-danger mb-1">Note : Please note that utility charges are non-refundable.</p> -->
                  <p class="text-danger">
                    Note : Platform and Facilitation / Utility fees are
                    Non-refundable
                  </p>
                  <div class="pt-1vw">
                    <!-- <v-btn
                      v-if="orderSummary.appointmentType === 'Appointment' || orderSummary.appointmentType === 'fromAccounts'"
                      class="btn btn-red-outline bg-light-danger text-danger font-weight-bold border-0 mr-4"
                      @click="closeModal(false, orderSummary)"
                    >Pay Later</v-btn> -->
                    <v-btn
                      v-if="useWallet && payableAmount > walletAmount"
                      @click="doPayment"
                      class="btn btn-grn-solid font-weight-bold"
                      >Pay Now</v-btn
                    >
                    <v-btn
                      v-else-if="useWallet && payableAmount <= walletAmount"
                      @click="doPayment"
                      class="btn btn-grn-solid font-weight-bold"
                      >Pay Now from wallet</v-btn
                    >
                    <v-btn
                      v-else
                      @click="doPayment"
                      class="btn btn-grn-solid font-weight-bold"
                      >Pay Now</v-btn
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-card-text>
    <v-card-text v-else class="order-summery">
      <div>
        <div class="col-sm-12 nopad">
          <table class="table">
            <thead>
              <tr>
                <th class="w40">
                  <p>{{ dr_label }} Name</p>
                </th>
                <th class="w25">
                  <p>Service Type</p>
                </th>
                <th class="w15"></th>
                <th class="w20"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="w40">
                  <p class="text-dark text-capitalize">
                    <b>{{ dr_label + orderSummary.doctorName }}</b>
                  </p>
                  <p>{{ orderSummary.doctorType }}</p>
                </td>
                <td class="w25">
                  <p class="text-dark">{{ orderSummary.appointmentType }}</p>
                </td>
                <td class="w15"></td>
                <td class="w20"></td>
              </tr>
              <tr>
                <td class="w40">
                  <p class="mb-2 text-dark">
                    <b v-if="showAddress">Address</b>
                  </p>
                  <p>
                    <b>{{ orderSummary.addressName }}</b>
                  </p>
                  <p v-if="showAddress">{{ orderSummary.address }}</p>
                </td>
                <td class="w25">
                  <div v-if="wallet > 0" class="d-align use-wallet">
                    <walletSVG />
                    <div>
                      <p class="mb-2">
                        YOU HAVE
                        <span>
                          <b>&#8377; {{ walletAmount | round }}</b>
                        </span>
                      </p>
                      <label class="container-check container-check-fluid">
                        <b>Use Wallet</b>
                        <input v-model="useWallet" type="checkbox" />
                        <span class="checkmarked"></span>
                      </label>
                    </div>
                  </div>
                  <!-- coupon code -->
                  <!-- <div v-if="isOC" class="mt-4">
                    <div class="coupon-code">
                      <label for>Coupons</label>
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Coupon Code"
                          v-model="code"
                        />
                        <p @click="validateCouponCode" class="mb-0 cursor">Apply</p>
                      </div>
                    </div>
                    <div>
                      <div v-if="codeValid" class="applied-coupon-code">
                        <div class="position-relative">
                          <p class="m-0">{{code}} Coupon Applied</p>
                          <v-icon @click="resetCode" class="cursor text-danger">mdi-close</v-icon>
                        </div>
                      </div>
                      <p
                        v-if="codeValid"
                        class="text-success"
                      >You saved additional &#8377; {{codeAmount}}</p>
                      <small v-if="codeInvalid" class="text-danger">Please enter a Valid Coupon Code</small>
                    </div>
                  </div> -->
                  <!-- end coupon code -->
                </td>
                <td colspan="2">
                  <p class="mb-3">Payment Summary</p>
                  <div
                    v-for="item in transaction.items"
                    :key="item.name"
                    class="d-align"
                  >
                    <p>
                      {{
                        item.name === "Appointment Charge"
                          ? "Consultation Charges"
                          : item.name
                      }}
                    </p>
                    <p>&#8377; {{ item.price | round }}</p>
                  </div>
                  <div v-if="transaction.platform_charges > 0" class="d-align">
                    <p>Platform Charges</p>
                    <p>&#8377; {{ transaction.platform_charges | round }}</p>
                  </div>
                  <!-- coupon code Discount-->
                  <div v-if="codeAmount > 0" class="d-align">
                    <p>Discount</p>
                    <p>&#8213; &#8377; {{ codeAmount }}</p>
                  </div>
                  <!-- end coupon code Discount-->
                  <div v-if="transaction.paid_amount > 0" class="d-align">
                    <p>Paid Amount</p>
                    <p>
                      - &#8377;
                      {{ transaction.paid_amount | round }}
                    </p>
                  </div>
                  <div v-if="useWallet" class="d-align">
                    <p>Used From Wallet</p>
                    <p>
                      - &#8377;
                      {{
                        payableAmount > walletAmount
                          ? walletAmount.toFixed(2)
                          : payableAmount.toFixed(2)
                      }}
                    </p>
                  </div>
                  <div v-if="utilityCharges > 0" class="d-align">
                    <p>Utility Charges</p>
                    <p>&#8377; {{ utilityCharges | round }}</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p class="text-right">
                    <b>
                      Total Amount
                      <span>
                        &#8377;
                        {{ totalAmount | round }}
                      </span>
                      <!-- <span
                        v-if="useWallet && payableAmount > walletAmount"
                      >&#8377; {{ payableAmount - walletAmount + transaction.charges }}</span>
                      <span v-else>&#8377; {{ payableAmount + transaction.charges }}</span> -->
                    </b>
                  </p>
                  <!-- <p class="text-danger mb-1">Note : Please note that utility charges are non-refundable.</p> -->
                  <p class="text-danger">
                    Note : Platform and Facilitation / Utility fees are
                    Non-refundable
                  </p>
                  <p v-if="canPayLater" class="mb-2">
                    Choose <b>Pay Later</b> to pay {{ payLaterSubject }} in cash
                    directly to the doctor.
                  </p>
                  <div class="pt-1vw">
                    <v-btn
                      v-if="canPayLater"
                      class="btn btn-red-outline bg-light-danger text-danger font-weight-bold border-0 mr-4"
                      :loading="payLaterLoader"
                      @click="payLater"
                      >Pay Later</v-btn
                    >
                    <v-btn
                      v-if="useWallet && payableAmount > walletAmount"
                      @click="doPayment"
                      class="btn btn-grn-solid font-weight-bold"
                      >Pay Now</v-btn
                    >
                    <v-btn
                      v-else-if="useWallet && payableAmount <= walletAmount"
                      @click="doPayment"
                      class="btn btn-grn-solid font-weight-bold"
                      >Pay Now from wallet</v-btn
                    >
                    <v-btn
                      v-else
                      @click="doPayment"
                      class="btn btn-grn-solid font-weight-bold"
                      >Pay Now</v-btn
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import walletSVG from "@/SVG/wallet";
import config from "@/config";
import {
  getTransaction,
  getTransactionV2,
  getWalletBalance,
  payNow,
  validateCoupon
} from "@/methods/payModule";
import { formats } from "@/methods/formats";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();

export default {
  components: {
    walletSVG
  },
  computed: {
    orderSummary() {
      return this.$store.getters["general/orderSummaryModal"];
    },
    showAddress() {
      const orderSummary = this.$store.getters["general/orderSummaryModal"];
      return orderSummary.addressName && orderSummary.addressName.length > 0;
    },
    payableAmount() {
      const pending = this.transaction.pending_amount;
      return Number(pending) - Number(this.codeAmount);
    },
    utilityCharges() {
      let charges = 0;
      if (
        this.transaction.utility_charges &&
        this.transaction.utility_charges.is_enabled
      ) {
        if (this.useWallet && this.walletAmount >= this.payableAmount) {
          charges = 0;
        } else if (this.useWallet && this.walletAmount < this.payableAmount) {
          if (this.transaction.utility_charges.type === "percentage") {
            charges =
              (this.payableAmount - this.walletAmount) *
              (this.transaction.utility_charges.value / 100);
          } else {
            charges =
              this.payableAmount -
              this.walletAmount +
              this.transaction.utility_charges.value;
          }
        } else {
          if (this.transaction.utility_charges.type === "percentage") {
            charges =
              this.payableAmount *
              (this.transaction.utility_charges.value / 100);
          } else {
            charges =
              this.payableAmount + this.transaction.utility_charges.value;
          }
        }
      } else charges = 0;
      return charges;
    },
    totalAmount() {
      let charges = 0;
      if (this.useWallet && this.walletAmount >= this.payableAmount) {
        charges = this.payableAmount;
      } else if (this.useWallet && this.walletAmount < this.payableAmount) {
        charges = this.payableAmount - this.walletAmount + this.utilityCharges;
      } else {
        charges = this.payableAmount + this.utilityCharges;
      }
      return charges;
    },
    isOC() {
      return this.orderSummary.appointmentType === "Online Consultation";
    },
    canPayLater() {
      return (
        this.orderSummary.appointmentType === "Appointment" ||
        this.orderSummary.appointmentType === "fromAccounts"
      );
    },
    payLaterSubject() {
      return this.orderSummary.appointmentType === "fromAccounts"
        ? "this bill"
        : "the consultation fees at the time of your appointment";
    }
  },
  filters: {
    round(value) {
      return Number(value).toFixed(2);
    },
    calculateItemTotal(value) {
      let total = 0;
      value.forEach(item => (total += Number(item.price)));
      return total.toFixed(2);
    }
  },
  watch: {
    orderSummary(newVal) {
      if (newVal.appointmentType == "Doctor-Subscription") {
        this.dr_label =
          this.$store.state.user.currentRole == "allied" ? "" : "Dr. ";
      } else {
        this.dr_label =
          newVal.is_allied && newVal.is_allied == true ? "" : "Dr. ";
      }
    }
  },
  methods: {
    resetCode() {
      this.code = "";
      this.codeValid = false;
      this.codeInvalid = false;
      this.codeAmount = 0;
    },
    validateCouponCode() {
      this.codeValid = false;
      this.codeInvalid = false;
      this.codeAmount = 0;
      validateCoupon(this, this.code).then(response => {
        if (response.status) {
          this.codeValid = true;
          if (response.data.type === "amount") {
            this.codeAmount = response.data.value;
          } else {
            const amount = this.payableAmount;
            this.codeAmount = amount * response.data.value * 0.01;
          }
        } else {
          this.codeInvalid = true;
        }
      });
    },
    getDate(payload) {
      return dayJS(payload).format(this.formats.date_format);
    },
    closeModal(redirect = true, orderSummary) {
      this.$store.dispatch("general/showOrderSummary", {
        visible: false,
        persistent: false,
        userId: "",
        transactionId: "",
        doctorName: "",
        doctorType: "",
        appointmentType: "",
        addressName: "",
        address: ""
      });
      (this.transaction = {
        items: []
      }),
        (this.wallet = false);
      this.useWallet = false;
      this.walletAmount = 0;
      if (redirect) {
        if (orderSummary.appointmentType === "fromAccounts") {
          this.$router.push("/patient/medical-accounts");
        } else {
          this.$router.push("/dashboard/patient/appointments/doctors");
        }
      }
    },
    payLater() {
      this.$swal({
        title: "Pay Later",
        text: `You will pay ${this.payLaterSubject} in cash directly to the doctor. Do you wish to continue?`,
        type: "info",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        allowOutsideClick: false
      }).then(result => {
        if (!result.value) return;

        //  A MEDICAL-ACCOUNTS BILL HAS NO APPOINTMENT TO CONFIRM - IT SIMPLY STAYS
        //  OUTSTANDING UNTIL IT IS SETTLED.
        if (this.orderSummary.appointmentType === "fromAccounts") {
          this.closeModal(true, this.orderSummary);
          return;
        }

        //  CONFIRM THE APPOINTMENT WITHOUT PAYING. UNTIL THIS SUCCEEDS THE BOOKING IS
        //  INVISIBLE TO BOTH THE PATIENT AND THE DOCTOR, SO ONLY NAVIGATE ON SUCCESS.
        this.payLaterLoader = true;
        this.$http
          .post(`${config.NEW_BASE_URL}api/v3/appointment/pay-later`, {
            transaction_id: this.orderSummary.transactionId
          })
          .then(response => {
            this.payLaterLoader = false;
            if (!response.body.status) {
              this.$swal({ title: "Error", text: response.body.message, type: "error" });
              return;
            }
            this.closeModal(true, this.orderSummary);
          })
          .catch(() => {
            this.payLaterLoader = false;
            this.$swal({
              title: "Error",
              text: "Could not confirm your appointment. Please try again.",
              type: "error"
            });
          });
      });
    },
    doPayment() {
      this.$store.dispatch(
        "general/showLoading",
        this.orderSummary.appointmentType
      );
      let successUrl = `${window.location.origin}/dashboard/patient/appointments/doctors`;
      let failureUrl = document.URL;
      if (this.orderSummary.appointmentType === "Pharmacy-Booking") {
        successUrl = `${
          window.location.origin
        }/patient/myOrders/pharmacy?status=${"accepted"}`;
        failureUrl = `${window.location.origin}/patient/myOrders/pharmacy`;
      }
      if (this.orderSummary.appointmentType === "Online Consultation") {
        successUrl = `${window.location.origin}/dashboard/patient/online-consultation`;
      }
      if (
        this.orderSummary.appointmentType === "Appointment" ||
        this.orderSummary.appointmentType === "fromAccounts"
      ) {
        failureUrl = `${window.location.origin}/dashboard/patient/appointments/doctors`;
      }
      if (this.orderSummary.appointmentType === "Doctor-Subscription") {
        successUrl = `${window.location.origin}/dashboard/doctor`;
        failureUrl = `${window.location.origin}/dashboard/doctor`;
      }
      if (this.orderSummary.appointmentType === "Centre-Subscription") {
        successUrl = `${window.location.origin}/mycenter/${this.orderSummary.role}`;
        failureUrl = `${window.location.origin}/mycenter/${this.orderSummary.role}`;
      }
      const code = this.codeValid ? this.code : false;

      payNow(
        this,
        this.transaction.transaction_id,
        successUrl,
        failureUrl,
        false,
        this.useWallet,
        code
      );
      this.closeModal(false, this.orderSummary);
    },
    fetchTransaction() {
      const idPresent = Boolean(this.orderSummary.transactionId);
      const transactionPresent = Boolean(this.transaction.status);
      if (!idPresent || transactionPresent) return;
      getTransactionV2(this, this.orderSummary.transactionId).then(
        transaction => {
          this.transaction = transaction;
          // add to config later from admin
        }
      );
    },
    fetchWalletBalance() {
      const idPresent = Boolean(this.orderSummary.userId);
      const transactionPresent = Boolean(this.transaction.status);
      if (!idPresent || transactionPresent) return;
      getWalletBalance(this, this.orderSummary.userId).then(details => {
        const amount = details.redeemable + (details.referal_balance || 0);
        if (amount > 0) {
          this.wallet = true;
          this.walletAmount = amount;
        }
      });
    },
    loadRazorpay() {
      const script = document.createElement("script");
      script.src = this.script;
      document.body.appendChild(script);
    }
  },
  data() {
    return {
      script: `https://checkout.razorpay.com/v1/checkout.js`,
      transaction: {
        items: []
      },
      wallet: false,
      useWallet: false,
      walletAmount: 0,
      dr_label: "Dr. ",
      formats,
      dayJS,
      code: "",
      codeValid: false,
      codeInvalid: false,
      codeAmount: 0,
      payLaterLoader: false
    };
  },
  created() {
    this.loadRazorpay();
  },
  mounted() {
    this.fetchTransaction();
    this.fetchWalletBalance();
  },
  beforeUpdate() {
    this.fetchTransaction();
    this.fetchWalletBalance();
  }
};
</script>
